import { api } from "roboflex-thalamus-request-handler";

/**
 * Endpoints de metas / insumos / produção anual.
 */
export default {
  /**
   * @param {{ produto_cod?: number, cod?: string, qt_meta: number, modo: string, considerar_estoque?: number|boolean }} params
   */
  async insumosMeta(params) {
    const { data } = await api.get("estrutura/produto/insumos-meta", { params });
    return data;
  },

  /**
   * @param {{ produto_cod?: number, cod?: string, ano: number }} params
   */
  async quantidadeAnoProduto(params) {
    const { data } = await api.get("producao/produto/quantidade-ano", { params });
    return data;
  },

  /**
   * @param {{ familia_id: number, ano: number, retornar_produtos?: number|boolean }} params
   */
  async quantidadeAnoFamilia(params) {
    const { data } = await api.get("producao/familia/quantidade-ano", { params });
    return data;
  },
};
